import NumberRole from 'config/chart-types/number';
import { AGGREGATE_FUNCTION_ENUM } from 'constants/aggregations';

function handleZeroDocuments(stageData) {
  const {
    documents,
    environment: { channels, chartType },
  } = stageData;

  if (
    documents.length === 0 &&
    chartType === NumberRole.name &&
    channels.value &&
    (channels.value.aggregate === AGGREGATE_FUNCTION_ENUM.COUNT ||
      channels.value.aggregate === AGGREGATE_FUNCTION_ENUM.DISTINCT)
  ) {
    return {
      documents: [{ value: 0 }],
    };
  }

  return {};
}

export default {
  input: ['documents', 'environment.channels', 'environment.chartType'],
  fn: handleZeroDocuments,
};
